import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import asyncComponent from '../../helpers/AsyncFunc';

const routes = [
  {
    path: 'invoice',
    component: asyncComponent(() => import('../Page/invoice-page/public'))
  },
  {
    path: 'courses',
    component: asyncComponent(() => import('../Page/public-registration/course-page'))
  },
  {
    path: 'courses/:courseId',
    component: asyncComponent(() => import('../Page/public-registration/course-page/view'))
  },
  {
    path: 'applications/create',
    component: asyncComponent(() => import('../Page/public-registration/application-page/create'))
  },
];

class AppRouter extends Component {
  render() {
    const { url, style } = this.props;
    return (
      <div style={style}>
          {routes.map(singleRoute => {
            const { path, exact, ...otherProps } = singleRoute;
            return (
              <Route
                exact={exact === false ? false : true}
                key={singleRoute.path}
                path={`${url}/${singleRoute.path}`}
                {...otherProps}
              />
            );
          })}
      </div>
    );
  }
}

export default AppRouter;
